module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_54-f36ce4bddae126a8ae0b224b569cfe6f.png";